import { Box, Flex, Heading, Icon, Tooltip } from '@chakra-ui/react';
import { PropsWithChildren } from 'react';
import { BiInfoCircle } from 'react-icons/bi';

export const PageHeader = ({ title, info, children }: PropsWithChildren<{ title: string; info?: React.ReactNode }>) => (
    <Flex mb={4} pb={4} justifyContent="space-between" alignItems="center" borderBottomWidth={1} gap={4}>
        <Flex gap={1}>
            <Heading size="lg">{title}</Heading>
            {info && (
                <Tooltip label={info} hasArrow>
                    <Box height="fit-content" cursor="pointer">
                        <Icon boxSize={6} as={BiInfoCircle} color="teal.200" />
                    </Box>
                </Tooltip>
            )}
        </Flex>
        {children}
    </Flex>
);
